import React, { useState } from 'react'

export default function useModalShow(onShowFunction, onCancelFunction) {
  const [visible, setVisible] = useState(false)
  const [payload, setPayload] = useState(false)

  async function onShow(object, type) {
    console.log('onShow')
    onShowFunction && (await onShowFunction())
    type && setPayload({ object, type })
    setVisible(true)
  }

  async function onCancel() {
    onCancelFunction && (await onCancelFunction())
    setPayload(false)
    setVisible(false)
  }

  return {
    visible,
    setVisible,
    isNew: !payload,
    onShow,
    onCancel,
    payload,
  }
}
